<div class="flex items-center justify-between rounded-lg border border-gray-200 p-2">
  <div class="flex items-center space-x-4">
    <wma-icon class="size-5 text-gray-500" [name]="icon() || 'information-circle'" />
    <div>
      <p class="font-medium">{{ name() }}</p>
      <p class="text-sm text-gray-500">{{ size() | fileSize }}</p>
    </div>
  </div>
  <button class="inline-flex" type="button" (click)="clearFile()">
    <wma-icon class="text-danger-500 size-5" name="x-circle" />
  </button>
</div>
